<template>
  <el-main>
    <h2>欢迎：使用阅卷-----{{name}} </h2>
    
  </el-main>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters([
      'name'
    ])
  },
  methods: {

  }
}
</script>